import o from "./_baseProperty.js";
import e from "./_basePropertyDeep.js";
import t from "./_isKey.js";
import m from "./_toKey.js";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/property.js
// module id = 1571
// module chunks = 67